// Fonts are served with the site rather than from Google, so pages don't wait on another
// server and visitors' IP addresses aren't sent to Google before cookie consent.
import './src/styles/fonts.css'
import './src/styles/global.css'
import { hasTrackingConsent, loadTrackers, trackPageView } from './src/utils/tracking'

export { wrapPageElement } from './src/gatsby-wrappers'

// Visitors who accepted cookies on an earlier visit get analytics right away
// (first-time visitors opt in through CookieBanner).
export const onClientEntry = () => {
  if (hasTrackingConsent()) loadTrackers()
}

// One page view per route, including the initial one.
export const onRouteUpdate = ({ location }) => {
  if (hasTrackingConsent()) trackPageView(location.pathname + location.search)
}
